export const truncate = (input, length) => {
  if (!input || input === 'null') {
    return 'N/A';
  }
  return input?.length > length ? `${input.substring(0, length)}...` : input;
};
